<template>
  <div id="app" >
    <headerNav></headerNav>

    <router-view  />

    <footer1></footer1>

   
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
    }
  },
  methods:{
    
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue